// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asset-preview .thumbnail[data-v-9b1f402e]{border-top-left-radius:unset;border-top-right-radius:unset;height:auto;text-align:center}.asset-preview .thumbnail img[data-v-9b1f402e]{max-height:198px;position:static;margin:0}.asset-preview .thumbnail.small img[data-v-9b1f402e]{max-height:98px}", ""]);
// Exports
module.exports = exports;
